<template>
  <v-app>
    <v-main>
      <div class="my-10 bg-secondary ma-auto pa-2">
        <div
          class="text-md-center my-5"
          style="font-family: heisei-mincho-std, serif;font-size: x-large;"
        >
          Nintendo Switch版 「エルミナージュORIGINAL ～闇の巫女と神々の指輪～ 」<br />実況・動画配信のガイドライン
        </div>
        <v-img
          :width="800"
          aspect-ratio="16/9"
          cover
          src="http://d-mebius.com/elminages/img/s01.jpg"
          class="ma-auto"
        ></v-img>
        <p
          style="line-height: 1.5em;"
          class="text-body1 text-md-h6 pa-3 pa-md-16 ma-auto text-md-center"
        >
          下記に実況・動画配信に関してのガイドラインを制定させて頂きます。
        </p>
        <div class="d_area">
          <p>
            ◆Ver.1.04以降のバージョンでプレイしていただきますようお願いいたします。
          </p>
          <p>
            ◆基本的にどこを実況、配信して頂きましても問題はございません。
          </p>

          <hr />
          <p>
            ◆キャプション等に下記の権利表記の記載をしてください。<br />
            <span
              style="
                text-decoration: underline;
                text-decoration-color: #fff000;
              "
              >© STARFISH-SD INC. © mebius.</span
            >
          </p>
          <p>
            ◆動画や配信で他者を誹謗中傷している場合や公序良俗に反していると判断した場合、
            動画の削除や配信中止のお願いをすることがございます。
          </p>
        </div>
        <p
          style="line-height: 1.5em;"
          class="text-h6 pa-3 ma-auto  text-md-center"
        >
          実況配信に関しまして、常識の範囲内であれば基本的に何をやって頂いても問題ございません。<br />
          なお、ゲームや開発・販売会社、クリエイターの品位・信用を損ねるものはご遠慮ください。
        </p>
      </div>
      <AppFooter />
      <!-- footerコンポーネントの使用 -->
    </v-main>
  </v-app>
</template>

<script>
  import AppFooter from "./AppFooter.vue";
  export default {
    components: {
      AppFooter,
    },
  };
</script>

<style scoped>
  .d_area {
    border: #fff solid 1px;
    padding: 2em;
    margin: 2em auto !important;
    line-height: 2.5em;
     max-width: 1280px;
  }
  .d_area p {
    margin: 1em auto;
  }
</style>
